import _ from "lodash"

export default class BeforeAfterImage {
  constructor(wrapper) {
    this._onStartDrag = this.startDrag.bind(this)
    this._onStopDrag = this.stopDrag.bind(this)
    this._onDrag = _.throttle(this.onDrag.bind(this), 10)

    this._addHover = null
    this._removeHover = null

    this.wrapper = wrapper
    this.slider = wrapper.querySelector(".before-after-slider")
    this.handler = wrapper.querySelector(".handler")
    this.handlerStyle = wrapper.querySelector(".handler-style")
    this.handlerStyleTriangles = wrapper.querySelector(".handler-style-triangles")
    this.before = wrapper.querySelector(".before-after-slider-image.before")
    this.after = wrapper.querySelector(".before-after-slider-image.after")
    this.imagecaption = wrapper.querySelector(".before-after-caption")
    this.direction = this.slider.dataset.direction || "horizontal"
    this.imagecatptions = JSON.parse(this.slider.dataset.imagecatptions)
    this.imageratio = JSON.parse(this.slider.dataset.imageratio)
    this.offset = parseInt(this.slider.dataset.offset, 10) || 50
    this.touchSupported = window.matchMedia("(pointer: coarse)").matches // a device with touch screen if true

    this.handlerSet = [this.handler, this.handlerStyle, this.handlerStyleTriangles]

    this.init()
  }

  init() {
    this.setSliderDivHeight()
    this.setOffset(this.offset)

    this.registerSliderBehavior()
    this.registerHoverToggleLabels()
  }

  setOffset(percent){
    if (this.direction === "vertical") {
      this.before.style.clipPath = `inset(0 0 ${100 - percent}% 0)`
      this.after.style.clipPath = `inset(${percent}% 0 0 0)`
      this.handler.style.top = `${percent}%`
    } else if (this.direction === "diagonalLeft") {
      this.handler.style.left = `${percent}%`
      this.handler.style.top = `${100 - percent}%`

      if (percent < 50) {
        const diagonalP = (50 - percent) * 2
        const diagonalP2 = percent * 2
        this.before.style.clipPath = `polygon(0 ${diagonalP}%, ${diagonalP2}% 100%, 0 100%)`
        this.after.style.clipPath = `polygon(0 0, 100% 0, 100% 100%, ${diagonalP2}% 100%, 0 ${diagonalP}%)`
      } else if (percent === 50) {
        this.before.style.clipPath = `polygon(0 0, 100% 100%, 0 100%)`
        this.after.style.clipPath = `polygon(100% 0, 100% 100%, 0 0)`
      } else { // percent > 50
        const diagonalP = (percent - 50) * 2
        const diagonalP2 = (100 - percent) * 2
        this.before.style.clipPath = `polygon(0 0, ${diagonalP}% 0, 100% ${diagonalP2}%, 100% 100%, 0 100%)`
        this.after.style.clipPath = `polygon(100% 0, 100% ${diagonalP2}%, ${diagonalP}% 0)`
      }
    } else if (this.direction === "diagonalRight") {
      this.handler.style.left = `${percent}%`
      this.handler.style.top = `${percent}%`
      if (percent < 50) {
        const diagonalP = percent * 2
        this.before.style.clipPath = `polygon(0 0,${diagonalP}% 0, 0 ${diagonalP}%)`
        this.after.style.clipPath = `polygon(${diagonalP}% 0, 100% 0, 100% 100%, 0 100%, 0 ${diagonalP}%)`
      } else if (percent === 50) {
        this.before.style.clipPath = `polygon(0 0, 100% 0, 0 100%)`
        this.after.style.clipPath = `polygon(100% 0, 100% 100%, 0 100%)`
      } else { // percent > 50
        const diagonalP2 = (percent - 50) * 2
        this.before.style.clipPath = `polygon(0 0, 100% 0, 100% ${diagonalP2}%,  ${diagonalP2}% 100%, 0 100%)`
        this.after.style.clipPath = `polygon(100% ${diagonalP2}%, 100% 100%, ${diagonalP2}% 100%)`
      }
    } else {
      this.before.style.clipPath = `inset(0 ${100 - percent}% 0 0)`
      this.after.style.clipPath = `inset(0 0 0 ${percent}%)`
      this.handler.style.left = `${percent}%`
    }

    let offset = this.offset

    if (offset > 50 && percent <= 50) {
      this.imagecaption.innerHTML = this.imagecatptions.after
    }

    if (offset <= 50 && percent > 50) {
      this.imagecaption.innerHTML = this.imagecatptions.before
    }

    // This is an initial call
    if (offset === percent) {
      if (percent > 50) {
        this.imagecaption.innerHTML = this.imagecatptions.before
      } else {
        this.imagecaption.innerHTML = this.imagecatptions.after
      }
    }

    this.offset = percent
  }

  setSliderDivHeight() {
    const rect = this.slider.getBoundingClientRect()
    this.slider.style.height = this.imageratio.height * (rect.width / this.imageratio.width) + "px"
  }

  registerSliderBehavior() {
    if (this.touchSupported) {
      this.handler.addEventListener("touchstart", this._onStartDrag, { passive: false })
      document.addEventListener("touchend", this._onStopDrag)
      document.addEventListener("touchmove", this._onDrag, { passive: false })
    } else {
      this.handler.addEventListener("mousedown", this._onStartDrag)
      document.addEventListener("mouseup", this._onStopDrag)
      document.addEventListener("mousemove", this._onDrag)
    }

    this.dragging = false
  }

  registerHoverToggleLabels() {
    if (this.slider.classList.contains("label-show-onMouseOver")) {
      this._addHover = (e) => {
        if (
          (e.type === 'mouseover' && e.toElement === this.slider && !this.handlerSet.includes(e.fromElement))
          || e.type === 'touchstart'
        ) {
          if (!this.slider.classList.contains("hover-active")) {
            this.slider.classList.add("hover-active")
          }
        }
      }
      this._removeHover = _.debounce((e) => {
        if (
          (e.type === 'mouseout' || e.fromElement === this.slider && !this.handlerSet.includes(e.toElement))
          || e.type === 'touchend'
        ) {
          if (this.slider.classList.contains("hover-active")) {
            this.slider.classList.remove("hover-active")
          }
        }
      }, 100)

      if (this.touchSupported) {
        this.slider.addEventListener("touchstart", this._addHover)
        this.slider.addEventListener("touchend", this._removeHover)
      } else {
        this.slider.addEventListener("mouseover", this._addHover)
        this.slider.addEventListener("mouseout", this._removeHover)
      }
    }
  }

  startDrag(e) {
    e.preventDefault()
    this.dragging = true
  }

  stopDrag(e) {
    e.preventDefault()
    this.dragging = false
  }

  onDrag(e) {
    if (!this.dragging) return
    let clientX, clientY
    if (e.touches) {
      clientX = e.touches[0].clientX
      clientY = e.touches[0].clientY
    } else {
      clientX = e.clientX
      clientY = e.clientY
    }

    const rect = this.slider.getBoundingClientRect()

    let percent
    if (this.direction === "vertical") {
      percent = ((clientY - rect.top) / rect.height) * 100
    } else { // for horizontal, diagonalLeft, and diagonalRight
      percent = ((clientX - rect.left) / rect.width) * 100
    }

    // Ensure that the percent is from 0 to 100
    percent = Math.max(0, Math.min(100, percent))

    this.setOffset(percent)
  }

  destroy() {
    if (this.touchSupported) {
      this.handler.removeEventListener("touchstart", this._onStartDrag)
      document.removeEventListener("touchend", this._onStopDrag)
      document.removeEventListener("touchmove", this._onDrag)
    } else {
      this.handler.removeEventListener("mousedown", this._onStartDrag)
      document.removeEventListener("mouseup", this._onStopDrag)
      document.removeEventListener("mousemove", this._onDrag)
    }

    if (this.slider.classList.contains("label-show-onMouseOver")) {
      if (this.touchSupported) {
        this.slider.removeEventListener("touchstart", this._addHover)
        this.slider.removeEventListener("touchend", this._removeHover)
      } else {
        this.slider.removeEventListener("mouseover", this._addHover)
        this.slider.removeEventListener("mouseout", this._removeHover)
      }
    }

    this.slider.classList.remove("hover-active")
  }
}
